// SPDX-License-Identifier: Apache-2.0
import { Box } from '@mui/system'
import { THEME_EXTRA, iframeLightBackgoundColor, iframeLightBlockTitle, theme } from '../../../helpers/theme'
import { githubDarkTheme } from '@uiw/react-json-view/githubDark'
import JsonView from '@uiw/react-json-view'
import React from 'react'
import { useSelector } from 'react-redux'
import { IState } from '../../../store/reducers'

interface OwnProps {
  data: object
}

type JsonViewProps = OwnProps

const MqJsonView: React.FC<JsonViewProps> = ({ data }) => {
  const { theme: iframeTheme } = useSelector((state: IState) => state.iframe)

  githubDarkTheme.background = iframeTheme === 'dark' ? theme.palette.background.default : iframeLightBackgoundColor
  githubDarkTheme.backgroundColor = iframeTheme === 'dark' ? theme.palette.background.default : iframeLightBackgoundColor
  githubDarkTheme.borderLeftWidth = 2
  githubDarkTheme.borderLeftColor = theme.palette.grey[500]
  githubDarkTheme.borderLeftStyle = 'dashed'

  const mqTheme = {
    ...githubDarkTheme,
    '--w-rjv-info-color': THEME_EXTRA.typography.subdued,
    '--w-rjv-type-null-color': theme.palette.warning.main,
    '--w-rjv-type-boolean-color': theme.palette.error.main,
    '--w-rjv-copied-color': theme.palette.primary.main,
    '--w-rjv-key-string': iframeTheme === 'dark' ? theme.palette.common.white : iframeLightBlockTitle,
    '--w-rjv-type-string-color': theme.palette.info.main,
    '--w-rjv-ellipsis-color': theme.palette.info.main,
    '--w-rjv-key-number': theme.palette.primary.main,
    '--w-rjv-type-float-color': theme.palette.primary.main,
  }
  
  return (
    <Box my={2}>
      <JsonView style={mqTheme} collapsed={2} value={data} />
    </Box>
  )
}

export default MqJsonView
